import React, { useContext } from 'react';
import { Segmented } from 'antd';
import { LangContext } from '../../contexts/langContext';
import { UncertainContext } from '../../contexts/uncertainContext';
import { timeFromDob, UNCERTAIN_KEYS_LIST } from '../utilsUncertain';
import { DropDown } from '../UiKit/DropDown';

export function UncertainSourceSelect({ className = 'x_guide_narrative_select', variant = 'select' }) {
  const context = useContext(LangContext);
  const uncertain = useContext(UncertainContext);
  const $ui = context.$ui;
  const $type = context.$type;
  const $profile = context.$profile;

  if (!uncertain?.available) return null;

  const currentLabel = uncertain.main === 'uncertain'
    ? '?'
    : (timeFromDob(uncertain.dobs?.[uncertain.main]) || '–');

  if (variant === 'dropdown') {
    return (
      <div className="x_uncertain_source_drop">
        <DropDown
          menuZ={false}
          id="uncertain"
          options={[]}
          addElements={<UncertainSourceSelect variant="segmented" />}
        >
          <div className="x_toggles_li">
            <span className="x_uncertain_source_q">{currentLabel}</span>
            <div className="t_icon">
              <div>expand_more</div>
            </div>
          </div>
        </DropDown>
      </div>
    );
  }

  if (variant === 'segmented') {
    return (
      <Segmented
        className="x_uncertain_source_segments"
        block
        size="small"
        value={uncertain.main}
        onChange={uncertain.setMain}
        aria-label={$ui('uncertain_choose')}
        options={[
          { label: <span className="x_uncertain_source_q">?</span>, value: 'uncertain' },
          ...UNCERTAIN_KEYS_LIST.map((key) => ({
            label: timeFromDob(uncertain.dobs?.[key]) || '–',
            value: key,
          })),
        ]}
      />
    );
  }

  const optionLabel = (key) => {
    const design = uncertain.designs?.[key];
    const time = timeFromDob(uncertain.dobs?.[key]);
    if (!design || design.id === 'dummy') return time || key;
    const profileId = design.profile?.[0] && design.profile?.[1]
      ? `${design.profile[0]}${design.profile[1]}`
      : '';
    const typeTitle = design.type ? $type(design.type, 'title_compact') : '';
    const profileTitle = profileId ? $profile(profileId, 'profile') : '';
    return [time, typeTitle, profileTitle].filter(Boolean).join(' · ');
  };

  return (
    <select
      className={className}
      value={uncertain.main}
      onChange={(e) => uncertain.setMain(e.target.value)}
      aria-label={$ui('uncertain_choose')}
    >
      <option value="uncertain">{$ui('uncertain_narrative')}</option>
      {UNCERTAIN_KEYS_LIST.map((key) => (
        <option key={key} value={key}>
          {optionLabel(key)}
        </option>
      ))}
    </select>
  );
}
